import React, { createContext, useState, useEffect } from "react";
import * as api from "./api";
import { useGlobalSpinnerActionsContext } from "./GlobalSpinnerContext";

export const ProductsContext = createContext();

const ProductsContextProvider = ({ children }) => {
    const setGlobalSpinner = useGlobalSpinnerActionsContext();
    const [products, setPosts] = useState([]);

    useEffect(() => {
        async function loadPosts() {
            try {
                setGlobalSpinner(true); // Show spinner
                let qrcode = "BINIXR10001##1";
                let [qrcodeid, tableno] = qrcode.split("##");
                let endpoint = `api/Product/MenuList?QROutletID=${qrcodeid}&TableName=${tableno}`;
                const response = await api.AxiosApi(endpoint);

                if (response?.data) {

                    setPosts(response.data);
                } else {
                    console.error("API response does not contain data:", response);
                    setPosts([]);
                }
            } catch (error) {
                console.error("Error fetching products:", error);
                setPosts([]);
            } finally {
                setGlobalSpinner(false); // Hide spinner
            }
        }

        loadPosts();
    }, [setGlobalSpinner]);

    return (
        <ProductsContext.Provider value={{ products: products || [] }}>
            {children}
        </ProductsContext.Provider>
    );
};

export default ProductsContextProvider;
